// Boiler Plate Imports
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  remove as removeNotification,
  add as addNotification,
} from "../../redux-store/notificationsSlice";
import { update as setBreadCrumbs } from "../../redux-store/breadCrumbsSlice";
import API from "../../api";
import colors from "../../theme/colors";
import { FullPageFormWrapper } from "../../components/Forms/shared";

// Conatiner Component Imports
import BreadCrumbs from "../../components/Navigation/breadcrumbs";
import ModalComponent from "../../components/Modal";

// Page Component Imports
import AdminNetworkForm from "../../components/Forms/adminNetworkForm";
import { useNavigate, useParams } from "react-router-dom";
import ConfirmForm from "../../components/Forms/confirmForm";
import { NoChartDataPlaceholder } from "../../components/NoDataPlaceholder";
import { CircularProgress } from "@mui/material";

const CreateNetwork = () => {
  const userProfile = useSelector((state) => state.user);
  const organization = useSelector((state) => state.organization);
  const { organizationId } = useParams();

  const [saving, setSaving] = useState(false);
  const [savingError, setSavingError] = useState(false);

  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const [organizationsList, setOrganizationsList] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dataLayer.GetAllOrganizations();
  }, []);

  useEffect(() => {
    //Set Bread Crumbs
    dispatch(
      setBreadCrumbs([
        {
          title: "Admin Networks",
          link: "/admin/networks",
        },
        {
          title: "Create Network",
          link: "/admin/networks/create",
        },
      ])
    );
  }, []);

  const dataLayer = {
    GetAllOrganizations: async () => {
      const { organizations } = await API.Organization.OrganizationsGetAll();
      setOrganizationsList(organizations);
    },
    CreateNetwork: async ({ createNetworkBodyData }) => {
      const res = await API.Network.NetworkCreate({
        createNetworkBodyData,
      });
    },
  };

  const handlers = {
    confirmModalSubmit: () => {
      navigate(`/admin/networks`);
    },
    confirmModalCancel: () => {
      setShowConfirmModal(false);
    },
    cancel: () => {
      setShowConfirmModal(true);
    },
    saveNetwork: async ({ name, organizationIds }) => {
      setSavingError("");
      setSaving(true);
      try {

        await dataLayer.CreateNetwork({
          createNetworkBodyData: {
            name,
            organizationIds,
          },
        });

        //Create Success Notification
        const id = new Date().getTime();
        dispatch(
          addNotification({
            id,
            severity: "success",
            title: "Success",
            message: "Network created successfully",
          })
        );
        setTimeout(() => {
          dispatch(removeNotification(id));
        }, 3000);
        navigate(`/admin/networks`);
      } catch (err) {
        let errorMessage = err;

        setSavingError(errorMessage);

        console.log(err);
        const id = new Date().getTime();
        dispatch(
          addNotification({
            id,
            severity: "error",
            title: "Error Creating Network",
            message: errorMessage,
          })
        );
        setTimeout(() => {
          dispatch(removeNotification(id));
        }, 3000);
      }
      setSaving(false);
    },
  };

  return (
    <>
      <FullPageFormWrapper>
        <h2>
          Create Network{" "}
          <span style={{ color: colors.gray }}> / Boreas Admin</span>
        </h2>
        {organizationsList.length ? (
          <AdminNetworkForm
            handleSave={handlers.saveNetwork}
            handleCancel={handlers.cancel}
            saving={saving}
            error={savingError}
            organizationsList={organizationsList}
          />
        ) : (
          <CircularProgress />
        )}
      </FullPageFormWrapper>
      <ModalComponent
        open={showConfirmModal}
        handleClose={handlers.confirmModalCancel}
        headerText={"Cancel Creating New Network"}
      >
        <ConfirmForm
          handleSave={handlers.confirmModalSubmit}
          handleCancel={handlers.confirmModalCancel}
          loading={false}
        >
          <div>
            <b>Are you sure you want to Cancel Creating New Network?</b>
            <p>You will lose all progress.</p>
          </div>
        </ConfirmForm>
      </ModalComponent>
    </>
  );
};

export default CreateNetwork;
